import { Navigate } from 'react-router-dom';

import { EmptyState } from '@/components/common/EmptyState/EmptyState';
import { LoadingState } from '@/components/common/LoadingState/LoadingState';
import { usePoliticalMatchFlow } from '@/hooks/usePoliticalMatchFlow';
import { useSeo } from '@/hooks/useSeo';
import { buildPageTitle } from '@/lib/seo';

export function PositionsTopicsPage(): JSX.Element {
  const { state, status, error } = usePoliticalMatchFlow();

  useSeo({
    title: buildPageTitle('Temas do Match Político'),
    description: 'Escolha os temas que quer comparar no Match Político.',
    canonicalPath: '/match-politico/temas',
    indexable: false,
  });

  if (status === 'loading') {
    return <LoadingState title="Carregando fluxo" messages={['Preparando o Match Político', 'Restaurando seu progresso', 'Seguindo para o questionário']} />;
  }

  if (status === 'error') {
    return <EmptyState tone="danger" title="Não foi possível carregar o fluxo" description={error ?? ''} />;
  }

  if (state.mode) {
    return <Navigate to="/match-politico/perguntas" replace />;
  }

  return <Navigate to="/match-politico" replace />;
}
